export default function trackEvent(event) {
  if (!window.hj) return
  window.hj?.('event', event)
}
